import React from "react";
import ScreenService from "../../services/ScreenService";
import ComcastCode from "./ComcastCode";
import { getModel } from "../../utils/models";

const SalesInfo = () => {
    const model = getModel();
    let containerClass, textClass;
    switch (model) {
        case "xumo":
            containerClass = `${ScreenService.isVertical ? "spectrum-sales-positioning-vertical " : "spectrum-sales-positioning"} spectrum-sales-container`;
            textClass = `${ScreenService.isVertical ? "spectrum-text-vertical" : "spectrum-text-horizontal"} spectrum-sales-text`;
            return (
                <div className={containerClass}>
                    <div className={textClass}>
                        <div className="spectrum-sales-text-content">Interested in purchasing EverPass?</div>
                        <div className="spectrum-sales-text-content"> Call Spectrum Business now</div>
                        <div className="spectrum-sales-text-content">
                            at <span className="spectrum-phone">{process.env.REACT_APP_SPECTRUM_SALES_NUMBER}</span>
                        </div>
                    </div>
                    <img className="spectrum-logo" src="https://cdn.upshow.tv/ui-assets/Spectrum_Logo.svg" alt="Spectrum logo" />
                </div>
            );
        case "xi6":
        case "xid":
        case "xg2v2":
            containerClass = `${ScreenService.isVertical ? "spectrum-sales-positioning-vertical" : "spectrum-sales-positioning"} spectrum-sales-container flex flex-col`;
            textClass = `${ScreenService.isVertical ? "spectrum-text-vertical" : "spectrum-text-horizontal"} spectrum-sales-text`;
            return (
                <div className={containerClass}>
                    <div className={textClass}>
                        <div className="spectrum-sales-text-content">Interested in purchasing EverPass?</div>
                        <div className="spectrum-sales-text-content">
                            {" "}
                            Call EverPass now at <span className="spectrum-phone">{process.env.REACT_APP_COMCAST_SALES_NUMBER}</span>
                        </div>
                    </div>
                    <ComcastCode />
                </div>
            );
        default: 
            return (<></>);
    }
};

export default SalesInfo;